<template>
    <div class="generic">
        <h3 v-text="item.client" class="generic__client"/>
        <div class="generic__sector">
            <span class="sector" v-if="item.sector" v-text="item.sector" />
        </div>
        <DataList
            :items="[
                {
                    title: 'Deal Type',
                    value: item.deal_type,
                    icon: 'deal',
                    isSector: false,
                },
                {
                    title: 'MA Contract',
                    value: item.ma_contact,
                    icon: 'value',
                    isSector: false,
                },
            ]"
        />
        <span class="generic__description" v-text="item.business_description" />
    </div>
</template>
<script>
    import DataList from '@components/DataList/List.vue';

    export default {
        name: 'GenericDocumentCard',
        components: { DataList },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
    }
</script>
<style lang="scss">
    @import '~@/theme/variables';

    .generic {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        row-gap: 1.5rem;
        border: .1rem solid $border;
        border-radius: .4rem;
        padding: 2rem;
        overflow: hidden;
        height: 100%;

        .generic__client {
            margin-bottom: 0;
            position: relative;
            font-size: 1.8rem;
            line-height: 2.3rem;
            font-weight: 500;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .generic__counterpart {
            font-size: 1.4rem;
            line-height: 1.7rem;
            color: $text;
            width: 100%;
        }

        .datalist {
            .dataitem {
                .dataitem__title {
                    font-size: 1.2rem;
                    line-height: 1.4rem;
                }
            }
        }

        .generic__description {
            color: #747484;
            font-size: 1.2rem;
            line-height: 1.6rem;
        }
    }
</style>
